<template>
  <embed-view v-if="viewerType == 'embeded'" :file="file" />
  <pdf-viewer v-else-if="viewerType == 'pdfjs'" :id="id" :file="file" />
  <iframe-view v-else-if="viewerType == 'iframe'" :file="file" />
  <objcet-view v-else-if="viewerType == 'pdfObject'" :file="file" />
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { UserAgent } from "./UserAgent";
import EmbedView from "./EmbedView.vue";
import IframeView from "./IframeView.vue";
import ObjcetView from "./ObjectView.vue";
import PdfViewer from "./PdfViewer.vue";

const ViewerType = {
  embeded: "embeded",
  pdfjs: "pdfjs",
  iframe: "iframe",
  pdfObject: "pdfObject",
} as const;

type PDFViewerType = (typeof ViewerType)[keyof typeof ViewerType];

export default defineComponent({
  name: "preview-pdf-view",
  components: {
    EmbedView,
    IframeView,
    ObjcetView,
    PdfViewer,
  },
  props: {
    id: { type: String, default: "" },
    file: { type: String, default: "" },
    saveAllowed: { type: Boolean, default: false },
    isMobile: { type: Boolean, default: false },
  },
  setup(props) {
    const ua = new UserAgent();

    const viewerType = computed((): PDFViewerType => {
      const browserType = ua.getBrowserType();
      if (browserType == "Electron" && props.saveAllowed) {
        // Electron & DL可
        return "embeded";
      } else if (
        browserType == "IE" ||
        browserType == "Edge" ||
        !props.saveAllowed ||
        props.isMobile
      ) {
        // IE or Edge or DL不可 or モバイルアプリ
        return "pdfjs";
      } else if (browserType == "Firefox") {
        return "embeded";
      } else if (browserType == "Safari") {
        return "iframe";
      } else {
        return "pdfObject";
      }
    });

    return { viewerType };
  },
});
</script>
